module.exports = __webpack_public_path__ + "img/yl3038.88cee4fd.png";